/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { nullReducer, payloadKeyReducer } from '@zcode/reducers'
import type { PermanentAddressMessageMeta } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  DONE_FETCHING_MESSAGE_LISTING_DETAILS,
  ERROR_FETCHING_MESSAGE_LISTING_DETAILS,
  START_FETCHING_MESSAGE_LISTING_DETAILS,
} from '../constants'

type ActionTypes = ExtractActions<Values<typeof actions>>

export const metaReducer = combineReducers<PermanentAddressMessageMeta, ActionTypes>({
  error: handleActions<string | null, ActionTypes>(
    {
      [ERROR_FETCHING_MESSAGE_LISTING_DETAILS]: payloadKeyReducer('error'),
      [START_FETCHING_MESSAGE_LISTING_DETAILS]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_MESSAGE_LISTING_DETAILS]: () => true,
      [DONE_FETCHING_MESSAGE_LISTING_DETAILS]: () => false,
    },
    false
  ),
})
